import { TransformBigInt } from '../util';

export class TokenPrice {
  @TransformBigInt()
  public native: bigint | undefined;
  public usd: number | undefined;

  constructor(native: bigint | undefined, usd: number | undefined) {
    this.native = native;
    this.usd = usd;
  }
}
